import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import {Tr} from "@/i18n/i18n";
import OnceCaller from "@/utils/once-caller";
import {PowerUpDescription, PowerUpUtils} from "@/utils/power-up-utils";
import {InterfaceMode, Player} from "@/store/player/types";
import CU from "@/utils/c-u";
import {TaskService} from "@/services/task-service";
import PowerUpDetailsPanel from "@/scenes.ui/power-up-details-panel";
import {MenuService} from "@/services/menu-service";

export default class PowerUpPanel extends Container {

    public shownPowerUpMarkers: string[] = [];

    public static MAX_ITEMS = 3;

    constructor(scene: Scene, x:number, y:number, player: Player, optionalAllItems?:PowerUpDescription[]){
        super(scene, x, y);

        let healthRecovering = player.healthRecoverAt && player.healthRecoverAt > 0;
        if(healthRecovering){
            this.y -= 20 * CU.S;
        }

        let allItems = optionalAllItems || PowerUpUtils.getItems();
        let items =  allItems.slice(0, PowerUpPanel.MAX_ITEMS);

        this.shownPowerUpMarkers = items.map(item => item.marker);

        if (items.length == 0 || player.interfaceMode == InterfaceMode.ORIGINAL){
            return;
        }

        scene.add.existing(this);
        this.setDepth(MenuService.DEFAULT_DEPTH);

        let button = SpriteUtils.addSprite(this.scene!,  -125 + (items.length -1 ) * 37 ,  0, Keys.UI_POWER_UP_BG_3);
        button.setOrigin(0.5, 1);
        button.setScale(button.scaleX, button.scaleY * 1.2  );
        this.add(button);
        button.alpha = 0.4;
        button.setAngle(90)

        for(let i = 0; i < items.length; i++){
            let scale = Number(items[i].scale) || 1;
            let deltaX = Number(items[i].deltaX) || 0;
            let deltaY = Number(items[i].deltaY) || 0;
            this.add(SpriteUtils.addSprite(scene, 37*i+3 + deltaX * 0.6, 5 + deltaY * 0.6, items[i].atlas, items[i].image, 0.6 * scale, 0.6 * scale));
        }

        let self = this;
        button.setInteractive().on('pointerup', () => {
            if(PowerUpDetailsPanel.instance){
                OnceCaller.doOnce("PowerUpDetailsPanel", () => {
                    PowerUpDetailsPanel.instance!.destroy();
                    PowerUpDetailsPanel.instance = undefined;
                }, 100);
            } else {
                OnceCaller.doOnce("PowerUpDetailsPanel", () => {
                    this.scene?.add.existing(new PowerUpDetailsPanel(this.scene!, self.x / CU.S + (items.length - 1) * 37, self.y / CU.S, PowerUpUtils.getItems()));
                }, 100);
            }

        }, button);
    }

}
